<template>
	<b-nav-item
		class="ma-cart-link"
		:active="isActive"
		@click.prevent="attemptGoToCart"
		@keydown.enter.prevent="attemptGoToCart"
		@keydown.space.prevent="attemptGoToCart"
	>
		<span class="cart-link-icon">
			<i class="bi bi-cart-fill nav-item-icon" />
		</span>
		<span class="label">{{ $t("label_cart") }}</span>
	</b-nav-item>
</template>
<script lang="ts" src="./cart-entry.ts"></script>
<style lang="scss" src="./cart-entry.scss"></style>
